module.exports = __webpack_public_path__ + "static/media/dock.6178a259.svg";